var React = require('react');

function IconLoading (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"50","cy":"23","r":"13","fill":"#fd8473"},React.createElement("animate",{"attributeName":"cy","dur":"1s","repeatCount":"indefinite","calcMode":"spline","keySplines":"0.45 0 0.9 0.55;0 0.45 0.55 0.9","keyTimes":"0;0.5;1","values":"23;77;23"})));
}

IconLoading.defaultProps = {"style":{"margin":"auto","background":"none","display":"block","shapeRendering":"auto"},"width":"200px","height":"200px","viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid"};

module.exports = IconLoading;

IconLoading.default = IconLoading;
